import { createTheme, ThemeProvider } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Companies from "./pages/Companies";
import Dashboard from "./pages/Dashboard";
import DashboardHome from "./pages/DashboardHome";
import EmployeeDetails from "./pages/EmployeeDetails";
import Employees from "./pages/Employees";
import Home from "./pages/Home";
import Login from "./pages/Login";
import NotStartedTrips from "./pages/NotStartedTrips";
import Tracking from "./pages/Tracking";
import localizationStrings, { firstTrySetLang } from "./utils/localizations";
import EmployeeTrips from "./pages/.toberemoved/EmployeeTrips";
import Houses from "./pages/Houses";
import TimeAttendance from "./pages/TimeAttendance";
import EmployeeAttendance from "./pages/.toberemoved/EmployeeAttendance";
import EmployeeListAttendance from "./pages/EmployeesListAttendance";
import PushNotifications from "./pages/PushNotifications";
import EmployeesPresent from "./pages/EmployeesPresent";
import axios from "axios";
import NotIrshadTrips from "./pages/NotIrshadTrips";

axios.defaults.withCredentials = true;

function App() {
  const getTheme = () =>
    createTheme({
      typography: {
        fontFamily: localizationStrings.getLanguage() == "en" ? "Aldrich" : "",
      },
      palette: {
        primary: {
          main: "#E8DABC",
        },
      },
      direction: localizationStrings.getLanguage() == "ar" ? "rtl" : "ltr",
    });
  const [theme, setTheme] = useState(getTheme());
  const [first, setFirst] = useState(1);
  const [reload, setReload] = useState({});

  const refreshTheme = () => {
    setTheme(getTheme());
  };

  useEffect(() => {
    if (first == 2) {
      const lng = localStorage.getItem("language");
      localizationStrings.setLanguage(lng || "ar");
      // localizationStrings.setLanguage('en');
      setFirst(first + 1);
      refreshTheme();
    } else if (first == 1) {
      setFirst(first + 1);
    }
  }, [first]);

  useEffect(() => {
    window.addEventListener("storage", (e) => {
      const lng = localStorage.getItem("language");
      localizationStrings.setLanguage(lng || "ar");

      // localizationStrings.setLanguage('en');
      refreshTheme();
    });
  }, []);

  const checkRoleExists = (role_id) => {
    return ((JSON.parse(localStorage.getItem("user") || "{}") || {}).roles || []).indexOf(role_id) > -1;
  };

  return (
    <div
      dir={localizationStrings.getLanguage() == "ar" ? "rtl" : "ltr"}
      style={{ fontFamily: localizationStrings.getLanguage() == "en" ? "Aldrich" : "GESndBook" }}
    >
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="dashboard-home" element={<DashboardHome reload={() => setReload({})} />}>
            <Route index element={<Tracking />} />
            <Route path="dashboard" element={<Dashboard />} />
            {checkRoleExists(1) && <Route path="employees" element={<Employees />} />}
            {checkRoleExists(1) && checkRoleExists(5) && (
              <Route path="employees/attendance/:EmployeeNo/:EmployeeName/" element={<EmployeeAttendance />} />
            )}
            {checkRoleExists(1) && checkRoleExists(5) && (
              <Route path="employees/attendance/:EmployeeNo/" element={<EmployeeAttendance />} />
            )}
            {checkRoleExists(1) && checkRoleExists(5) && (
              <Route path="employees-attendance" element={<EmployeeListAttendance />} />
            )}
            {checkRoleExists(1) && <Route path="employees/:EmployeeNo/:EmployeeName/" element={<EmployeeDetails />} />}
            {checkRoleExists(1) && <Route path="employees/:EmployeeNo/" element={<EmployeeDetails />} />}
            {checkRoleExists(1) && <Route path="push-notifications" element={<PushNotifications />} />}
            {checkRoleExists(1) && <Route path="employees-present" element={<EmployeesPresent />} />}
            {checkRoleExists(2) && <Route path="employees-trips" element={<EmployeeTrips />} />}
            {checkRoleExists(2) && <Route path="employees-trips/:LeavingNo" element={<Houses />} />}
            {checkRoleExists(2) && <Route path="not-started" element={<NotStartedTrips />} />}
            {checkRoleExists(2) && <Route path="not-irshad" element={<NotIrshadTrips />} />}
            {checkRoleExists(4) && <Route path="company-login" element={<Companies />} />}
            {checkRoleExists(3) && <Route path="tracking" element={<Tracking />} />}
            {checkRoleExists(5) && <Route path="time-attendance" element={<TimeAttendance />} />}
          </Route>
        </Routes>
      </ThemeProvider>
    </div>
  );
}

export default App;

function Comp() {
  console.log("here");
  window.location.href = "http://localhost:5555" + window.location.pathname;
  return null;
}
